import { Injectable } from '@angular/core';
import { BridgeConfig, NativeBridgeWindow } from '../models/interfaces/native-bridge-window';
import { bridgeConfigConstants } from '../constants/bridge-config.constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { deviceMessageProperties } from '../enums/device-message-properties';
import { deviceMessageId } from '../enums/device-message-id.enum';
import { SetWebVersionMessage } from '../models/interfaces/set-web-version-message';
import { deviceEnvironmentId } from '../enums/device-environment-id';
import { CloverService } from './clover.service';
import { StorageService } from './storage.service';
import { NativeBridgeSanitizerService } from './native-bridge-sanitizer.service';

@Injectable({
  providedIn: 'root'
})
export class NativeBridgeService {
  public nativeBridgeWindow = this.getWindow() as NativeBridgeWindow;
  private _messageRecievedSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public $messageReceived: Observable<any> = this._messageRecievedSubject.asObservable();

  constructor(
    private cloverService: CloverService,
    private storageService: StorageService,
    private nativeBridgeSanitizer: NativeBridgeSanitizerService
  ) {
    window.addEventListener('message', (event) => {
      console.log('Event: ', event.origin);

      if (typeof event.data !== 'string' || event.data === '') {
        return;
      }
      this.sendMessage(event.data);
    });
  }

  private getWindow(): Window {
    if (typeof window !== 'undefined' && typeof window === 'object') {
      return window;
    }
  }

  getNativeBridgeWindow() {
    return this.nativeBridgeWindow;
  }

  nativeBridgeIsActive(key: string) {
    return key in window;
  }

  getCurrentMessagesValue() {
    return this._messageRecievedSubject.getValue();
  }

  //funcion expuesta para que la apk pueda consumir a traves del bridge - se recibe mje y se guarda en observable
  sendMessage(messageRecieved: string) {
    const sanitizedMessage = this.nativeBridgeSanitizer.sanitizeMessage(messageRecieved);
    const property = sanitizedMessage.message_id;

    if (sanitizedMessage) {
      this._setMessage({
        ...this._messageRecievedSubject.getValue(),
        [property]: JSON.parse(messageRecieved)
      });

      if (sanitizedMessage.message_id == deviceMessageId.GET_WEB_VERSION) {
        this._sendMessageWithWebVersionToApk();
      }
      if (sanitizedMessage.message_id == deviceMessageId.SET_ENVIRONMENT) {
        this.storageService.set('appEnvironment', sanitizedMessage.environment);
        if (sanitizedMessage.environment == deviceEnvironmentId.CLOVER && sanitizedMessage.terminal_id) {
          this.cloverService.setTerminalId(sanitizedMessage.terminal_id);
        }
      }
    } else {
      return new Error('Error al sanitizar mensaje recibido');
    }
  }

  private _setMessage(message: any) {
    this._messageRecievedSubject.next(message);
  }

  sendMessageToDevice(message: string) {
    const activeBridgeConfig: BridgeConfig = bridgeConfigConstants.find((config) =>
      this.nativeBridgeIsActive(config.windowProperty)
    );
    const sanitizedMessage = this.nativeBridgeSanitizer.sanitizeMessage(message);

    if (activeBridgeConfig && sanitizedMessage) {
      this.nativeBridgeWindow[activeBridgeConfig.windowProperty].sendMessage(JSON.stringify(sanitizedMessage));
    } else {
      throw new Error('Error al enviar mensaje a través de apk bridge.');
    }
  }

  private _sendMessageWithWebVersionToApk() {
    const responseId = this._messageRecievedSubject?.getValue()[deviceMessageId.GET_WEB_VERSION]?.request_id;
    const version = require('../../../../package.json').version;

    if (responseId && version) {
      const setWebVersionMessage: SetWebVersionMessage = {
        message_id: deviceMessageId.SET_WEB_VERSION,
        response_id: responseId,
        web_version: version
      };
      this.sendMessageToDevice(JSON.stringify(setWebVersionMessage));
    } else {
      return new Error('No se pudo obtener responseId / version');
    }
  }

  getEnvironment() {
    const appEnvironment = this.storageService.get('appEnvironment');
    return appEnvironment ? appEnvironment : deviceEnvironmentId.WEB;
  }
}
